import { render } from "./PageInicio.vue?vue&type=template&id=b5c60fa2&scoped=true"
import script from "./PageInicio.vue?vue&type=script&lang=js"
export * from "./PageInicio.vue?vue&type=script&lang=js"

import "./PageInicio.vue?vue&type=style&index=0&id=b5c60fa2&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5c60fa2"]])

export default __exports__